import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

export const routes: FeatureRoute[] = [
  { path: "ayarlar", Component: lazy(() => import("./SettingsHomePage")) },
  { path: "ayarlar/sirket", Component: lazy(() => import("./CompanyPage")) },
  { path: "ayarlar/organizasyon", Component: lazy(() => import("./OrgPage")) },
  { path: "ayarlar/kullanicilar", Component: lazy(() => import("./UsersPage")) },
  { path: "ayarlar/izin-turleri", Component: lazy(() => import("./LeaveTypesPage")) },
  { path: "ayarlar/tatiller", Component: lazy(() => import("./HolidaysPage")) },
  { path: "ayarlar/belge-turleri", Component: lazy(() => import("./DocumentTypesPage")) },
  { path: "ayarlar/masraf-kategorileri", Component: lazy(() => import("./ExpenseCategoriesPage")) },
  { path: "ayarlar/denetim", Component: lazy(() => import("./AuditPage")) },
  { path: "ayarlar/destek-erisimi", Component: lazy(() => import("./SupportAccessPage")) },
  { path: "ayarlar/baslangic", Component: lazy(() => import("./SetupWizardPage")) },
];
